var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 4195 c-94 -33 -158 -145 -138 -240 19 -87 92 -158 176 -170 22 -3 1085 -5 2361 -3 l2320 3 42 24 c126 72 145 241 39 339 -24 22 -61 45 -82 51 -27 8 -740 11 -2359 11 -1950 -1 -2326 -3 -2359 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 2759 c-175 -70 -180 -322 -8 -394 33 -13 288 -15 2378 -15 2090 0 2345 2 2378 15 152 64 172 273 34 370 l-44 30 -2356 2 c-1535 1 -2366 -2 -2382 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 1325 c-22 -8 -58 -34 -81 -57 -84 -89 -79 -214 10 -296 24 -22 61 -45 82 -51 55 -15 4653 -15 4708 0 60 17 123 82 142 146 13 45 14 62 3 106 -15 65 -83 139 -144 156 -29 8 -693 11 -2360 11 -1975 -1 -2326 -3 -2360 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ef9aadb2124c3ec1123e58c624a3d3bd.svg";
export { ForwardRef as ReactComponent };